/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import * as PropTypes from 'prop-types';
import {FilterType, ProductDropdown} from "../../../../data/finders.model";
import Block from "../../../atoms/layout/Block";
import {Title} from "../../../atoms/text/Title";
import {connect} from "react-redux";
import {SearchTypeAhead} from "../../../molecules/finder/SearchTypeAhead";
import stripDiacritics from "react-bootstrap-typeahead/es/utils/stripDiacritics";
import {getLinkedProducts} from "../../../../selectors/finder";
import {addLinkedProducts, removeLinkedProducts} from "../../../../actions/finder";
import {createSelector} from 'reselect';
import {RemovableItem} from "../../../atoms/RemovableItem";
import {InformationIcon} from "../../../molecules/finder/InformationIcon";

class LinkedProductFilter extends React.Component {

    static propTypes = {
        filter: PropTypes.oneOfType([PropTypes.shape(ProductDropdown), PropTypes.any]),
        products: PropTypes.arrayOf(PropTypes.string),
        linkedProducts: PropTypes.arrayOf(PropTypes.string),
        addLinkedProducts: PropTypes.func,
        removeLinkedProduct: PropTypes.func
    };

    static stringFiltering = (product, search) => {
        return !search || stripDiacritics((product || "").toLowerCase()).indexOf(stripDiacritics((search.text || "").toLowerCase())) !== -1;
    };

    render() {
        const { filter, products, linkedProducts, addLinkedProducts, removeLinkedProducts } = this.props;

        if (products && products.length === 0 && linkedProducts.length === 0) {
            return null;
        }

        return  <Block className={`finder__filter filter-${filter.type.toLowerCase()}`}>
            <Block className="finder__filter-header">
                {filter.title && <Block className="p-flex p-justify-space-between">
                    <span className={"text-small-semi-bold"}>{filter.title}</span>
                    {filter.informationIcon && <InformationIcon message={filter.informationIcon} type="INFO"/>}
                </Block>}
            </Block>
            <Block className={`finder__filter-body`}>
                <Block className={"p-margin-bottom-sm"}>
                    <SearchTypeAhead
                        placeholder={filter.placeholder}
                        emptyLabel={false}
                        items={products}
                        size={'sm'}
                        paginate={false}
                        maxItems={5}
                        disableFreeText
                        onSelect={(item) => addLinkedProducts([item])}
                        searchIcon={<span></span>}
                        filterBy={LinkedProductFilter.stringFiltering} />
                </Block>

                {linkedProducts && <Block className={"selected__tags"}>
                    {linkedProducts.map(str => <RemovableItem className={"tag-label"} label={str} remove={() => removeLinkedProducts([str])} />)}
                </Block>}
            </Block>
        </Block>
    }

}

const mapStateToProps = () => {
    const productsSelector = createSelector(
        (state, ownProps) => (ownProps.availableItems || []).flatMap(recipe => recipe.linkedProducts || []).uniqueValues(),
        getLinkedProducts,
        (options, selected) => options.filter(option => selected.indexOf(option) === -1)
    );

    return (state, ownProps) => ({
        products: productsSelector(state, ownProps),
        linkedProducts: getLinkedProducts(state)
    });
};

const mapActionsToProps = {
    addLinkedProducts,
    removeLinkedProducts
};

export default connect(mapStateToProps, mapActionsToProps)(LinkedProductFilter);
